import { useState } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CardAction from '../../../components/card/CardAction';
import LessonPlay from '../../lessonplay/LessonPlay';
import './PreviewLessonAction.scss';
import ChurnZeroService from '../../../services/ChurnZeroService';
import { CHURNZERO_CONSTANT } from '../../../constants/ChurnZeroConstant';
import { useTrackTeacherActivityPreview } from './hooks/TeacherTrackingActivityHooks';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';

/**
 * Play Lesson Action Container
 */
const defaultProps = {
  className: '',
  label: '',
  user: null,
  userProfile: null,
  terminologies: {},
};

export default function PreviewLessonAction(props) {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { lesson, label, className, user, userProfile, terminologies } = mergedProps;
  const [open, setOpen] = useState(false);

  useTrackTeacherActivityPreview(open, user, lesson);

  return (
    <>
      <CardAction
        icon={<VisibilityIcon aria-hidden='false' />}
        label={label}
        actionHandler={() => {
          ChurnZeroService.trackEvent(CHURNZERO_CONSTANT.SETUP, 'Explore platform', user);
          setOpen(true);
        }}
        className={`btn-gray-background preview-lesson-card-action ${className}`}
        data-test='preview-lesson-card-action'
        tabIndex={0}
        aria-hidden='false'
      />
      {open && (
        <LessonPlay
          open={open}
          handleClose={() => { setOpen(false); }}
          lesson={lesson}
          isPreviewMode
          user={user}
          userProfile={userProfile}
          terminologies={terminologies}
        />
      )}
    </>
  );
}
